import React from "react";

const SimpleInputTextField = ({
  label,
  value,
  onChange,
  maxLength = 50,
  placeHolder,
  wrapperClassName,
  defaultValue,
  isReadOnly = false,
  isDisabled = false,
}) => {
  return (
    <div>
      {label && <label className="field-label">{label}</label>}
      <div
        className={`input-field-wrapper ${
          wrapperClassName && wrapperClassName
        }`}
      >
        <input
          type="text"
          value={value}
          onChange={onChange}
          disabled={isDisabled}
          maxLength={maxLength}
          readOnly={isReadOnly}
          className="input-textfield input-textfield-without-icon"
          placeholder={placeHolder}
          defaultValue={defaultValue}
        />
      </div>
    </div>
  );
};

export default SimpleInputTextField;
